import React from 'react';
import { useNavigate } from 'react-router-dom';
import { communitySection } from '../mock';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useSiteContent } from '../contexts/SiteContentContext';

export const CommunitySection = () => {
  const navigate = useNavigate();
  const content = useSiteContent();

  const handleContact = () => {
    navigate('/contact');
  };

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-black text-white mb-6">
            {content?.communityTitle || communitySection.title}
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed">
            {content?.communityDescription || communitySection.description}
          </p>
          <Button
            onClick={handleContact}
            className="bg-[#FF1B6D] hover:bg-[#E01660] text-white font-bold text-lg px-10 py-7 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl hover:shadow-[#FF1B6D]/50"
          >
            {content?.communityCTA || communitySection.ctaText}
            <ArrowRight className="ml-2" size={20} />
          </Button>
        </div>
      </div>
    </section>
  );
};